<template>
  <div v-if="getRoute() !== 'signin'" class="top-0 position-sticky z-index-sticky"> 
    <navbar is-blur="blur start-0 end-0 shadow" btn-background="bg-gradient-success" :dark-mode="true" /> 
  </div>
  <main v-loading="loading"
    class="not-for-print main-content position-relative max-height-vh-100 h-100 border-radius-lg">
    <!-- nav -->
    <router-view @set-loading="setLoading" @to-pdf="toPdf" />
    <app-footer v-show="showFooter" />
  </main>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/Footer.vue"; 
import CryptoJS from "crypto-js"; 

function formatNumber(num) {
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(num);
}

export default {
  name: "App",
  components: {
    Navbar,
    AppFooter,
  },
  data() {
    return {
      bindNavbar: true,
      logoMain: null,
      loading: false,
      eksperText: null,
      sideVis: true,
      clinicAktInfo: null,
      clinicReyesVis: false,
      clinicAktVis: false,
      clinicInfo: {
        sumInsured: null,
        caught: null,
        registerId: null,
        editSumInsured: null,
        status: null,
        saveTitle: null,
        expertiseSumInsured: null,
      },
      retentionSumSum: null,
      clinicTable: null,
    };
  },
  computed: {
    vatSum() {
      return this.clinicAktInfo.vatSum != 0
        ? `${formatNumber(this.clinicAktInfo.vatSum)} manat (${this.clinicAktInfo.vatSumStr
        })` +
        (this.clinicAktInfo.vatNfc
          ? ` ƏDV tətbiq olunan məbləğ: ${formatNumber(
            this.clinicAktInfo.vatSum / (1.0 - 1.0 / 1.18)
          )}`
          : "")
        : "      ---";
    },
    dateStamp() {
      let actDate = this.clinicAktInfo.actDate;
      let validDate = actDate ? new Date(actDate) : new Date("2000-01-01");
      if (validDate >= new Date("2023-10-01")) {
        return true;
      } else {
        return false;
      }
    },
    signName() {
      let value = false;
      if (this.clinicAktInfo.signerName === "Rəna Daneşvar") {
        value = "@/assets/img/logos/AktAtes/signRena.png";
      } else {
        value = "@/assets/img/logos/AktAtes/signNigar.png";
      }
      return value;
    },
  },
  created() {
    if (window.localStorage.getItem("jwt") === null) {
      window.localStorage.setItem(
        "jwt",
        CryptoJS.AES.encrypt(JSON.stringify("none"), "secret_key").toString()
      );
      window.localStorage.setItem(
        "roles",
        CryptoJS.AES.encrypt(
          JSON.stringify([{ id: null }]),
          "secret_key"
        ).toString()
      );
      window.localStorage.setItem(
        "user",
        CryptoJS.AES.encrypt(
          JSON.stringify([{ id: null }]),
          "secret_key"
        ).toString()
      );
    } 
  }, 
  methods: {  
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return (routeArr[1] || "").toLowerCase();
    }, 
  },
};
</script>